import {
  XMarkIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/solid';
import classNames from 'classnames';
import Image from 'next/image';
import { useState, useMemo, useEffect } from 'react';
import { Swiper as SwiperType } from 'swiper';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import Button from '@/components/Button';
import { ProductGalleryProps } from '@/components/ProductGallery/types';
import ProductImages from '@/components/ProductImages';

import styles from './styles.module.scss';
import { Props } from './types';

const FullScreenGallery = ({
  isOpen,
  onClick,
  images,
  title,
  currentIndex,
  thumbnail,
  isMobile,
  mainPhoto,
}: Props & ProductGalleryProps) => {
  const modalClass = classNames(styles.container, isOpen && styles.opened);

  const galleryPhotos = useMemo(() => {
    if (!images) return [];
    return [{ id: mainPhoto, url: mainPhoto }, ...images];
  }, [images, mainPhoto]);

  const [productImagesSwiperRef, setProductImagesSwiperRef] =
    useState<SwiperType | null>(null);
  const [mainPhotoSwiperRef, setMainPhotoSwiperRef] =
    useState<SwiperType | null>(null);

  useEffect(() => {
    if (currentIndex) {
      productImagesSwiperRef?.slideTo(currentIndex);
      mainPhotoSwiperRef?.slideTo(currentIndex);
    }
  }, [currentIndex]);

  return (
    <div className={modalClass}>
      <div className={styles.closeModal} onClick={onClick}>
        <Button isIconType variant="icon">
          <XMarkIcon />
        </Button>
      </div>
      <div className={styles.images}>
        {!isMobile && (
          <div className={styles.galleryWrapper}>
            <ProductImages
              images={images}
              title={title}
              thumbnail={thumbnail}
              setSwiperRef={setProductImagesSwiperRef}
              isMobile={isMobile}
              parentSwiperRef={mainPhotoSwiperRef}
            />
          </div>
        )}
        <div className={styles.photoWrapper}>
          <Button
            isIconType
            variant="icon"
            className={`${styles.navigationButton} fullscreen-main-photo-button-prev`}
          >
            <ChevronLeftIcon />
          </Button>
          <Swiper
            modules={[Navigation]}
            navigation={{
              nextEl: '.fullscreen-main-photo-button-next',
              prevEl: '.fullscreen-main-photo-button-prev',
            }}
            slidesPerView={1}
            spaceBetween={10}
            onSwiper={(swiper: SwiperType) => {
              if (setMainPhotoSwiperRef) setMainPhotoSwiperRef(swiper);
            }}
            onSlideChange={(swiper: SwiperType) => {
              if (productImagesSwiperRef)
                productImagesSwiperRef.slideTo(swiper.activeIndex);
            }}
          >
            {galleryPhotos.map((image, index) => {
              return (
                <SwiperSlide key={index}>
                  <Image
                    src={image.url}
                    alt={`Zdjęcie produktu ${title}`}
                    width={800}
                    height={1000}
                    priority
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
          <Button
            isIconType
            variant="icon"
            className={`${styles.navigationButton} fullscreen-main-photo-button-next`}
          >
            <ChevronRightIcon />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FullScreenGallery;
